export function generateTrainingUrl(training: TrainingEntity) {
  const sessionId = training?.sessions?.length
    ? `/${
        training?.sessions.sort(
          (a, b) => (a.order_index || 0) - (b.order_index || 0)
        )?.[0].id
      }`
    : '';

  return `/werkplaats/training-details/${training?.id}${sessionId}`;
}
